import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
import { AnnualReportHighlightedStepProps } from "models/propTypes/annualAccountPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { HighlightedStep, TitleIcon, ProfileImage, StyledButton } from "components/common";
import useExportAttachmentsDialog from "../../export/useExportAttachmentsDialog";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import useDueWeekText from "./useDueWeekText";

const AnnualReportHighlightedStep: React.FC<AnnualReportHighlightedStepProps> = ({
  currentStep,
  isCurrentStepLast,
}) => {
  const { profileId, userName } = useSelector((state: AppState) => ({
    profileId: state.auth.loggedInUser.personId,
    userName: state.auth.loggedInUser.name.split(" ")[0],
  }));

  const { displayExportAttachmentsDialog } = useExportAttachmentsDialog();
  const { companyId, companyName } = useSelector((state: AppState) => ({
    companyId: state.auth.selectedCompany.id,
    companyName: state.auth.selectedCompany.name ?? "",
  }));

  const getDueWeekText = useDueWeekText();
  const getDescriptions = (step: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStep) => {
    const subTexts = [];
    if (step.stateDescription) {
      subTexts.push(step.stateDescription);
    }

    const dueText = getDueWeekText(step);
    if (dueText) {
      subTexts.push(dueText);
    }

    return subTexts;
  };

  return currentStep ? (
    <HighlightedStep
      icon={
        currentStep?.state === WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepState.Blocked ? (
          <TitleIcon icon={IconDefinitionConstants.WBlocked} displayType={StyleEnums.DisplayType.Warning} />
        ) : currentStep?.responsible ===
          WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Revisor ? (
          <ProfileImage id={profileId} name={userName} />
        ) : currentStep?.responsible ===
          WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Customer ? (
          <ProfileImage id={companyId} name={companyName} />
        ) : (
          <ProfileImage className={cssExports.wint} />
        )
      }
      title={currentStep?.title ?? ""}
      description={getDescriptions(currentStep)}
      toolTip={currentStep?.dueDateDescription}
    >
      {isCurrentStepLast ? (
        <Grid item>
          <StyledButton size="sm" onClick={displayExportAttachmentsDialog}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.ExportAttachments)}
          </StyledButton>
        </Grid>
      ) : (
        <></>
      )}
    </HighlightedStep>
  ) : (
    <></>
  );
};

export default AnnualReportHighlightedStep;
